import styled, { keyframes } from 'styled-components'

const expandWrapper = keyframes`
  0% { opacity: 0 }
  100% { opacity: 1 }
`

const scrollTopMini = keyframes`
  0% { 
    opacity: 0;
    transform: translateY(30px);
  }
  100% { 
    opacity: 1;
    transform: translateY(60px);
  }
`

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  @media (min-width: 768px) {
    background: ${p => p.expanded ? '#1D3739': 'transparent'}
  }
`

export const WrapperExpanded = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  font-family: Amorim Sans, sans-serif;
  opacity: 0;

  animation: ${expandWrapper} .5s ease-out forwards;

  @media (min-width: 768px) {
    max-width: 75%;
    height: 100vh;
    min-height: 500px;
    margin-left: 25%;
  }
`

export const ContainerSVG = styled.div`
  display: flex;
  height: calc(100% - 100px);
  align-items: center;
  padding-top: 5%;

  @media (min-width: 768px) {
    min-width: 500px;
    height: 70vh;
    min-height: 400px;
  }
`
export const ContainerMenu = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  height: 36px;
  bottom: 30px;
`

export const MenuFactoryShowRoom = styled.ul`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 300px;
  height: 36px;
  list-style: none;
`

export const ButtonFactoryShowroom = styled.li`
  font-family: 'Amorim Sans Book';
  &:not(.separator){
    color: #FFFFFF;
    text-transform: uppercase;
    font-size: 19px;
    cursor: pointer;
    opacity: .3;
    transition: all .3s linear;
    letter-spacing: .5px;
    &:hover {
    opacity: .6;
    }

    &.active {
      opacity: 1;
    }
  }
  
  &.separator {
    position: relative;
    width: 1px;
    height: 36px;
    &:after {
      position: absolute;
      content: '';
      width: 1px;
      background: #FFF;
      height: 36px;
      top: 0;
      left: 50%;
    }
  }
`

export const ContainerMini = styled.div`
  position: absolute;
  top: 60px;
  right: 10px;
  width: 314px;
  height: 200px;
  

  @media (min-width: 768px) {
  
    top: initial;
    left: initial;
    bottom: 70px;
    right: 60px;
  }
`

export const WrapperMini = styled.div`
  background: rgba(29, 55, 57, .7);
  pointer-events: all;
  transition: all .3s ease;
  cursor: pointer;
  opacity: 0;
  animation: ${scrollTopMini} .5s ease-out forwards;
  width: 100%;
  height: 100%;
  padding: 8px;
  
  svg {
    * > * {
      opacity: 0.85;
      stroke-width: 1;
    }
  }
  &:hover {
    background: rgba(26, 42, 43, 1);

    svg {
      

      * > * {
        opacity: 1;
        stroke-width: 1;
      }

      path {
        stroke-width: 1;
      }
    }

    .maximizar {
      &:after {
        transform: translate(9px, 9px);
        opacity: 1;
      }
    }
  }

  @media (min-width: 768px) {
    animation: ${expandWrapper} .5s ease-out forwards;
  }
`
export const CompassSVGMini = styled.div`
  position: absolute;
  svg{width: 36px; height: 36px;}
  left: calc(50% - 18px);
  top: calc(50% - 18px);
`
export const ContainerSVGMini = styled.div`
  display: flex;
  height: 90%;
  align-items: center;
  padding-top: 5%;
  svg{
    width: 100%;
    height: 100%;
    transition: all .1s ease;
  }
`
export const ContainerInfoMini = styled.div`
  pointer-events: all;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #1D3739d4;
  padding: 50px;
  display: flex;
  height: 100vh !important;
  width: 100vw !important;
  text-align:center;
  flex-direction: column !important;
  justify-content: space-between !important;
  color: #FFF;
  text-transform: uppercase;
  font-family: 'Amorim Sans Book';
  overflow: hidden !important;
  z-index: 2000 !important;
  .info-title{
    letter-spacing: 0.6px;
    font-size: 18px;
  }
  .info-tap{
    letter-spacing: 0.8px;
    font-size: 12px;
  }
`

export const ButtonMaximizar = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 30px;
  height: 30px;
  font-size: 30px;

  &:after {
      position: absolute;
      content: '';
      top: 0;
      left: 0;
      opacity: 0;
      transform: translate(14px, 14px);
      width: 11px;
      height: 11px;
      border-top: solid 2px rgba(255,255,255, .6);
      border-left: solid 2px rgba(255,255,255, .6);
      transition: all .2s ease-out;
  }
`


export const Title = styled.div`
  width: 100%;
  font-family: 'Amorim Sans Serif';
  font-size: 20px;
  line-height: 30px;
  color: #fff;
`
export const Line = styled.div`
  height: 1px;
  background: #FFF;
  width: 100%;
  margin-top: 10px;  
`